import { useState, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { sizes } from '../media';
export var useIsPhone = function (PHONE_BREAKPOINT) {
  if (PHONE_BREAKPOINT === void 0) {
    PHONE_BREAKPOINT = sizes.mobileLandscape;
  }
  var _a = useState(window.innerWidth <= PHONE_BREAKPOINT),
    isPhone = _a[0],
    setIsPhone = _a[1];
  var handleWindowResize = useDebouncedCallback(function () {
    return setIsPhone(window.innerWidth <= PHONE_BREAKPOINT);
  }, 250)[0];
  useEffect(function () {
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  });
  return isPhone;
};